var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", { staticClass: "page-heading" }, [_vm._v("Assets")]),
    _vm._v(" "),
    _c("div", { staticClass: "flex" }, [
      _c(
        "nav",
        { staticClass: "fixed-bar navbar navbar-expand-lg navbar-light bgNav" },
        [
          _c("div", { staticClass: "dropdownItems" }, [
            _c("div", { staticClass: "btn-group" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-info dropdown-toggle",
                  attrs: {
                    type: "button",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                },
                [_vm._v("\n            Add +\n          ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown-menu" }, [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function($event) {
                        return _vm.$refs.addProp.openDialog()
                      }
                    }
                  },
                  [_vm._v("3D Model")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function($event) {
                        return _vm.$refs.addEffect.openDialog()
                      }
                    }
                  },
                  [_vm._v("Visual Effect")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function($event) {
                        return _vm.$refs.addModel.openDialog()
                      }
                    }
                  },
                  [_vm._v("Character Model")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function($event) {
                        return _vm.$refs.addCharacterAnimation.openDialog()
                      }
                    }
                  },
                  [_vm._v("Character Animation")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function($event) {
                        return _vm.$refs.addSound.openDialog()
                      }
                    }
                  },
                  [_vm._v("Sound")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function($event) {
                        return _vm.$refs.addVideo.openDialog()
                      }
                    }
                  },
                  [_vm._v("Video")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function($event) {
                        return _vm.$refs.addOverlay.openDialog()
                      }
                    }
                  },
                  [_vm._v("Images")]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { margin: "0px auto" }, attrs: { id: "tabs" } },
            [
              _c(
                "button",
                {
                  staticClass: "tablink",
                  attrs: { id: "threeDModelId" },
                  on: {
                    click: function($event) {
                      return _vm.visitDiv("threeDModel")
                    }
                  }
                },
                [_vm._v("\n          3D Model\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "tablink",
                  attrs: { id: "visualEffectId" },
                  on: {
                    click: function($event) {
                      return _vm.visitDiv("visualEffect")
                    }
                  }
                },
                [_vm._v("\n          Visual Effect\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "tablink",
                  attrs: { id: "characterModelId" },
                  on: {
                    click: function($event) {
                      return _vm.visitDiv("characterModel")
                    }
                  }
                },
                [_vm._v("\n          Character Model\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "tablink",
                  attrs: { id: "characterAnimationId" },
                  on: {
                    click: function($event) {
                      return _vm.visitDiv("characterAnimation")
                    }
                  }
                },
                [_vm._v("\n          Character Animation\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "tablink",
                  attrs: { id: "voiceId" },
                  on: {
                    click: function($event) {
                      return _vm.visitDiv("voice")
                    }
                  }
                },
                [_vm._v("\n          Voice\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "tablink",
                  attrs: { id: "soundId" },
                  on: {
                    click: function($event) {
                      return _vm.visitDiv("sound")
                    }
                  }
                },
                [_vm._v("\n          Sound\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "tablink",
                  attrs: { id: "videoId" },
                  on: {
                    click: function($event) {
                      return _vm.visitDiv("video")
                    }
                  }
                },
                [_vm._v("\n          Video\n        ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "tablink",
                  attrs: { id: "imagesId" },
                  on: {
                    click: function($event) {
                      return _vm.visitDiv("images")
                    }
                  }
                },
                [_vm._v("\n          Images\n        ")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "allDiv" },
        [
          _c("props", { ref: "addProp", staticClass: "my-5" }),
          _vm._v(" "),
          _c("effect", { ref: "addEffect", staticClass: "my-5" }),
          _vm._v(" "),
          _c("character-model", { ref: "addModel", staticClass: "my-5" }),
          _vm._v(" "),
          _c("character-animation", {
            ref: "addCharacterAnimation",
            staticClass: "my-5"
          }),
          _vm._v(" "),
          _c("voice", { ref: "addVoice", staticClass: "my-5" }),
          _vm._v(" "),
          _c("sound", { ref: "addSound", staticClass: "my-5" }),
          _vm._v(" "),
          _c("Video", { ref: "addVideo", staticClass: "my-5" }),
          _vm._v(" "),
          _c("overlay", { ref: "addOverlay", staticClass: "my-5" })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c571e686", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c571e686","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Assets.vue
// module id = null
// module chunks = 